module.exports = __webpack_public_path__ + "img/logoENT.a45b3437.png";